import React, { useEffect } from 'react';
import VisitsTable from './Components/VisitsTable';
import { useHistory } from 'react-router-dom';

const MyVisitsPage = () => {
  const history = useHistory();

  return (
    <div className="w-full h-full">
      <div className="pb-1">
        <VisitsTable
          preselectedFutureVisits={history?.location?.state?.fromPayment}
        />
      </div>
    </div>
  );
};

export default MyVisitsPage;
